module.exports = __webpack_public_path__ + "img/24-grand-wagoneer-nav.4e2db897.png";